export default __webpack_public_path__ + "static/media/pathway_active.2b313be8.svg";